interface Circle {
  id: string;
  name: string;
  tagline: string;
  desc: string;
  members: string;
  posts: string;
  heat: string;
  tag: string;
  hot: boolean;
  cover: string;
}

interface FeedItem {
  id: string;
  time: string;
  circle: string;
  title: string;
  excerpt: string;
  tags: string[];
  heat: string;
  comments: string;
  verified: boolean;
  image?: string;
}

interface GroupItem {
  id: string;
  name: string;
  category: string;
  members: string;
  todayPosts: string;
  avatar: string;
  badge: string;
}

interface TagItem {
  name: string;
  count: string;
  trend: "up" | "new" | "hot";
}

interface ZoneItem {
  id: string;
  name: string;
  icon: string;
  desc: string;
  count: string;
}

interface StatItem {
  label: string;
  value: string;
  suffix: string;
  icon: string;
}

interface TickerLine {
  label: string;
  text: string;
}

export const navItems = [
  { label: "圈子分区", href: "#circles" },
  { label: "标签聚合", href: "#tags" },
  { label: "群组广场", href: "#groups" },
  { label: "热门话题", href: "#topics" },
  { label: "分区导航", href: "#zones" },
];

export const tickerLines: TickerLine[] = [
  { label: "实时", text: "「影视幕后」圈子新增 26 条同事件多角度整理" },
  { label: "热议", text: "话题 #剪辑争议# 讨论量 30 分钟内上涨 41%" },
  { label: "新群", text: "群组「深夜树洞」今日开放第 9 批加入名额" },
  { label: "标签", text: "高频标签「宣发物料」已被 1.2 万个话题引用" },
  { label: "分区", text: "「品牌观察」分区完成本周内容脉络归档" },
];

export const heroStats: StatItem[] = [
  { label: "活跃圈子", value: "186", suffix: "个", icon: "ri-group-2-line" },
  { label: "今日话题", value: "4.2", suffix: "千条", icon: "ri-fire-line" },
  { label: "标签总量", value: "3.6", suffix: "万枚", icon: "ri-price-tag-3-line" },
  { label: "在线群组", value: "912", suffix: "个", icon: "ri-chat-smile-2-line" },
];

export const circles: Circle[] = [
  {
    id: "circle-01",
    name: "影视幕后",
    tagline: "剧组风云 · 片场见闻",
    desc: "聚焦影视项目台前幕后的动态与传闻，同一事件在这里按多角度还原时间脉络。",
    members: "12.8万",
    posts: "3,260",
    heat: "97.2万",
    tag: "影视",
    hot: true,
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20film%20clapperboard%20and%20reels%20on%20warm%20cream%20paper%20background%2C%20editorial%20magazine%20still%20life%2C%20soft%20diffused%20light%2C%20muted%20warm%20tones%2C%20minimal%20composition&width=800&height=600&seq=circle-film-01&orientation=landscape",
  },
  {
    id: "circle-02",
    name: "综艺风向",
    tagline: "镜头之外 · 现场声音",
    desc: "从录制现场到成片剪辑，梳理综艺话题的来龙去脉与圈层讨论焦点。",
    members: "9.4万",
    posts: "2,180",
    heat: "81.5万",
    tag: "综艺",
    hot: true,
    cover:
      "https://readdy.ai/api/search-image?query=stage%20spotlights%20and%20empty%20studio%20chairs%20on%20warm%20beige%20backdrop%2C%20editorial%20magazine%20photography%2C%20soft%20light%2C%20muted%20warm%20palette%2C%20minimal%20composition&width=800&height=600&seq=circle-variety-02&orientation=landscape",
  },
  {
    id: "circle-03",
    name: "网红动态",
    tagline: "直播切片 · 内容风向",
    desc: "跟踪内容创作者的更新节奏与直播片段，标签化归拢争议与澄清。",
    members: "15.2万",
    posts: "4,410",
    heat: "112.6万",
    tag: "创作者",
    hot: true,
    cover:
      "https://readdy.ai/api/search-image?query=smartphone%20on%20tripod%20with%20ring%20light%20in%20cozy%20warm%20studio%2C%20editorial%20still%20life%2C%20cream%20background%2C%20soft%20natural%20light%2C%20muted%20tones&width=800&height=600&seq=circle-creator-03&orientation=landscape",
  },
  {
    id: "circle-04",
    name: "品牌内幕",
    tagline: "产品拆解 · 配料对比",
    desc: "把营销话术翻译成可核对的细节，围绕上新、翻车与澄清建立话题链路。",
    members: "7.6万",
    posts: "1,940",
    heat: "63.8万",
    tag: "消费",
    hot: false,
    cover:
      "https://readdy.ai/api/search-image?query=stacked%20shipping%20cartons%20and%20product%20samples%20on%20warm%20cream%20surface%2C%20editorial%20magazine%20still%20life%2C%20soft%20light%2C%20muted%20warm%20tones&width=800&height=600&seq=circle-brand-04&orientation=landscape",
  },
  {
    id: "circle-05",
    name: "游戏圈层",
    tagline: "版本改动 · 战队重组",
    desc: "版本更新与赛事变化催生的话题集散地，按战队、版本、赛事分区讨论。",
    members: "18.9万",
    posts: "5,120",
    heat: "128.4万",
    tag: "电竞",
    hot: true,
    cover:
      "https://readdy.ai/api/search-image?query=game%20controller%20and%20headphones%20on%20warm%20cream%20desk%2C%20cozy%20editorial%20still%20life%2C%20soft%20diffused%20light%2C%20muted%20warm%20palette&width=800&height=600&seq=circle-game-05&orientation=landscape",
  },
  {
    id: "circle-06",
    name: "财经小道",
    tagline: "行业动向 · 数据对照",
    desc: "把零散的行业消息按时间归档，对照公开数据梳理可信度与后续走向。",
    members: "6.3万",
    posts: "1,470",
    heat: "48.9万",
    tag: "行业",
    hot: false,
    cover:
      "https://readdy.ai/api/search-image?query=financial%20newspaper%20and%20calculator%20on%20warm%20paper%20background%2C%20editorial%20magazine%20still%20life%2C%20soft%20light%2C%20muted%20warm%20tones&width=800&height=600&seq=circle-finance-06&orientation=landscape",
  },
];

export const groups: GroupItem[] = [
  {
    id: "group-01",
    name: "吃瓜前线补给站",
    category: "综合爆料",
    members: "3.2万",
    todayPosts: "186",
    badge: "今日最活跃",
    avatar:
      "https://readdy.ai/api/search-image?query=cute%20cartoon%20watermelon%20slice%20badge%20on%20cream%20background%2C%20flat%20minimal%20illustration%2C%20warm%20muted%20palette&width=400&height=400&seq=group-melon-01&orientation=squarish",
  },
  {
    id: "group-02",
    name: "深夜树洞",
    category: "匿名交流",
    members: "2.8万",
    todayPosts: "142",
    badge: "限时开放",
    avatar:
      "https://readdy.ai/api/search-image?query=minimal%20moon%20and%20stars%20badge%20illustration%20on%20cream%20background%2C%20flat%20vector%20style%2C%20warm%20muted%20palette&width=400&height=400&seq=group-moon-02&orientation=squarish",
  },
  {
    id: "group-03",
    name: "剪辑研究所",
    category: "影视讨论",
    members: "1.9万",
    todayPosts: "98",
    badge: "内容质量高",
    avatar:
      "https://readdy.ai/api/search-image?query=minimal%20scissors%20and%20film%20strip%20badge%20on%20cream%20background%2C%20flat%20illustration%2C%20warm%20muted%20palette&width=400&height=400&seq=group-edit-03&orientation=squarish",
  },
  {
    id: "group-04",
    name: "品牌打假办",
    category: "消费避坑",
    members: "2.4万",
    todayPosts: "121",
    badge: "干货集中",
    avatar:
      "https://readdy.ai/api/search-image?query=minimal%20magnifying%20glass%20badge%20on%20cream%20background%2C%20flat%20illustration%2C%20warm%20muted%20palette&width=400&height=400&seq=group-check-04&orientation=squarish",
  },
  {
    id: "group-05",
    name: "追剧打卡团",
    category: "观剧日常",
    members: "4.1万",
    todayPosts: "233",
    badge: "更新最快",
    avatar:
      "https://readdy.ai/api/search-image?query=minimal%20popcorn%20bucket%20badge%20on%20cream%20background%2C%20flat%20illustration%2C%20warm%20muted%20palette&width=400&height=400&seq=group-popcorn-05&orientation=squarish",
  },
  {
    id: "group-06",
    name: "同城线索圈",
    category: "本地见闻",
    members: "1.5万",
    todayPosts: "76",
    badge: "新群上线",
    avatar:
      "https://readdy.ai/api/search-image?query=minimal%20map%20pin%20badge%20on%20cream%20background%2C%20flat%20illustration%2C%20warm%20muted%20palette&width=400&height=400&seq=group-city-06&orientation=squarish",
  },
];

export const feedItems: FeedItem[] = [
  {
    id: "feed-01",
    time: "09:42",
    circle: "影视幕后",
    title: "某古装项目宣发物料临时调整，未公开片段流出后讨论迅速升温",
    excerpt:
      "原定上线的预告与花絮在发布前被替换，圈内围绕剪辑版本出现多种说法。圈子内已按时间线整理出完整脉络，并把物料变更前后做了逐帧对照。",
    tags: ["剪辑争议", "宣发物料", "影视幕后"],
    heat: "32.6万",
    comments: "1,842",
    verified: true,
    image:
      "https://readdy.ai/api/search-image?query=empty%20director%20chair%20and%20camera%20on%20warm%20film%20set%2C%20editorial%20magazine%20photography%2C%20cream%20tones%2C%20soft%20diffused%20light&width=800&height=600&seq=feed-film-01&orientation=landscape",
  },
  {
    id: "feed-02",
    time: "09:15",
    circle: "综艺风向",
    title: "暑期档综艺录制现场排期变动，嘉宾阵容出现替换传闻",
    excerpt:
      "多个渠道提到录制时间被压缩，节目组尚未回应。群组内把已确认的通告与网传名单分开罗列，方便判断可信度。",
    tags: ["录制现场", "阵容变动"],
    heat: "24.1万",
    comments: "1,210",
    verified: false,
    image:
      "https://readdy.ai/api/search-image?query=colorful%20stage%20lighting%20rig%20on%20warm%20beige%20background%2C%20editorial%20magazine%20style%2C%20soft%20light%2C%20muted%20warm%20palette&width=800&height=600&seq=feed-variety-02&orientation=landscape",
  },
  {
    id: "feed-03",
    time: "08:58",
    circle: "品牌内幕",
    title: "老牌零食上新后配料表被逐条对比，客服话术同步更新",
    excerpt:
      "配料顺序与包装标注存在细微差异，社区把新旧版本并排贴出。讨论集中在代工厂切换与口感变化两条主线上。",
    tags: ["配料对比", "消费避坑", "品牌内幕"],
    heat: "19.7万",
    comments: "968",
    verified: true,
    image:
      "https://readdy.ai/api/search-image?query=package%20unboxing%20flat%20lay%20on%20warm%20cream%20paper%2C%20editorial%20still%20life%2C%20soft%20natural%20light%2C%20muted%20warm%20tones&width=800&height=600&seq=feed-brand-03&orientation=landscape",
  },
  {
    id: "feed-04",
    time: "08:33",
    circle: "游戏圈层",
    title: "赛事版本改动落地，老牌战队战术体系迎来重组窗口",
    excerpt:
      "版本更新后强势阵容被削弱，论坛与群组同步出现大量复盘帖。分区已按战队维度归档，方便对照不同赛区的应对方案。",
    tags: ["版本改动", "战队重组"],
    heat: "28.3万",
    comments: "1,567",
    verified: false,
    image:
      "https://readdy.ai/api/search-image?query=arcade%20tokens%20and%20joystick%20on%20warm%20cream%20surface%2C%20editorial%20still%20life%2C%20soft%20light%2C%20muted%20warm%20palette&width=800&height=600&seq=feed-game-04&orientation=landscape",
  },
  {
    id: "feed-05",
    time: "08:04",
    circle: "网红动态",
    title: "直播间抽奖规则说明更新，多位创作者同步调整口播话术",
    excerpt:
      "同一时段内多个头部账号更新了活动说明，社区据此整理出规则对照表，并把争议点拆成独立标签便于检索。",
    tags: ["直播切片", "规则更新"],
    heat: "15.4万",
    comments: "742",
    verified: false,
  },
  {
    id: "feed-06",
    time: "07:41",
    circle: "财经小道",
    title: "行业消息面出现新说法，公开数据暂未出现对应变化",
    excerpt:
      "传言与公开披露信息存在时间差，群组把可核对的部分单独标注出来，并持续跟踪后续更新，避免以讹传讹。",
    tags: ["行业动向", "数据对照"],
    heat: "11.2万",
    comments: "486",
    verified: true,
  },
  {
    id: "feed-07",
    time: "07:12",
    circle: "影视幕后",
    title: "杀青物料释出节奏被拉长，相关话题进入二次发酵阶段",
    excerpt:
      "首轮讨论降温后，因一组幕后花絮重新被提起。圈子内已把前后两轮话题的讨论焦点做了对照梳理。",
    tags: ["幕后花絮", "影视幕后"],
    heat: "9.8万",
    comments: "392",
    verified: false,
  },
  {
    id: "feed-08",
    time: "06:47",
    circle: "综艺风向",
    title: "成片与现场版本差异被逐段比对，剪辑思路成为焦点",
    excerpt:
      "社区把现场观众反馈与成片顺序并排对照，整理出几个明显不同的段落。相关讨论已归入「剪辑争议」标签。",
    tags: ["剪辑争议", "现场声音"],
    heat: "8.6万",
    comments: "318",
    verified: true,
  },
];

export const tags: TagItem[] = [
  { name: "剪辑争议", count: "8,240", trend: "hot" },
  { name: "宣发物料", count: "6,915", trend: "up" },
  { name: "直播切片", count: "12,386", trend: "hot" },
  { name: "配料对比", count: "5,102", trend: "up" },
  { name: "版本改动", count: "9,874", trend: "hot" },
  { name: "战队重组", count: "4,530", trend: "new" },
  { name: "录制现场", count: "7,061", trend: "up" },
  { name: "幕后花絮", count: "10,428", trend: "hot" },
  { name: "消费避坑", count: "3,884", trend: "new" },
  { name: "行业动向", count: "2,967", trend: "up" },
  { name: "同城线索", count: "2,145", trend: "new" },
  { name: "匿名投稿", count: "14,772", trend: "hot" },
  { name: "时间线整理", count: "6,318", trend: "up" },
  { name: "逐帧对照", count: "3,240", trend: "new" },
  { name: "澄清声明", count: "5,706", trend: "up" },
  { name: "话题归档", count: "4,088", trend: "new" },
  { name: "圈内爆料", count: "11,943", trend: "hot" },
  { name: "群组共建", count: "2,560", trend: "up" },
];

export const zones: ZoneItem[] = [
  {
    id: "zone-01",
    name: "热榜分区",
    icon: "ri-fire-line",
    desc: "按热度排序的话题集散地，实时刷新讨论量最高的内容。",
    count: "42 个话题",
  },
  {
    id: "zone-02",
    name: "时间线分区",
    icon: "ri-time-line",
    desc: "以快讯流形态按时间串联同一事件的全部节点。",
    count: "128 条脉络",
  },
  {
    id: "zone-03",
    name: "圈子分区",
    icon: "ri-group-2-line",
    desc: "按兴趣圈层归档内容，进入即可看到同圈讨论。",
    count: "186 个圈子",
  },
  {
    id: "zone-04",
    name: "标签分区",
    icon: "ri-price-tag-3-line",
    desc: "用标签交叉筛选，把跨圈层的话题聚到一起。",
    count: "3.6 万标签",
  },
  {
    id: "zone-05",
    name: "群组分区",
    icon: "ri-chat-smile-2-line",
    desc: "集中讨论同一类爆料的小组，成员共建话题脉络。",
    count: "912 个群组",
  },
  {
    id: "zone-06",
    name: "归档分区",
    icon: "ri-archive-line",
    desc: "沉淀已形成结论的话题，便于回看完整讨论过程。",
    count: "2,340 份归档",
  },
];

export const topicFilters = [
  "全部话题",
  "剪辑争议",
  "直播切片",
  "配料对比",
  "版本改动",
  "幕后花絮",
  "行业动向",
];